import React, { useMemo, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Chip,
  Link,
} from '@mui/material';
import styled from '@emotion/styled';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Mail';
import { v4 as uuid } from 'uuid';
import { useAppSelector } from '../../../store/reduxHooks';
import { FileUpload } from '../../../components/FileUpload';
import config from '../../../assets/config';

const FormTopStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

const FormImageLeftStyled = styled(Box)(({}) => ({
  width: 256,
  height: 128,
  overflow: 'hidden',
  marginRight: 20,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
}));

const FromTestRightStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
}));

const FormContactRowStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
}));

function VenueReadOnly({ data }: any) {
  const [imageKey, setImageKey] = useState<string>(
    'profile_picture' + data._id + uuid()
  );
  const address: [] = useMemo(() => {
    if (data.address) {
      return data.address.split(/\n/g);
    }
    return [];
  }, []);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Chip label={data.uuid} variant='outlined' />
      </Grid>
      <Grid item xs={12}>
        <FormImageLeftStyled
          id={imageKey}
          key={imageKey}
          sx={{
            backgroundImage: `url(${config.backendPath}/api/admin/v1/file/profile/${data.uuid}?q=${imageKey})`,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body1'>{data.name}</Typography>
      </Grid>
      <Grid item xs={12}>
        {address.map((item: any) => (
          <Typography variant='body2'>{item}</Typography>
        ))}
      </Grid>
      <Grid item sm={12} md={6}>
        <Link
          target='_blank'
          href={`https://www.google.com/maps/@${data.location.coordinates.join(
            ','
          )},15z`}
        >
          View in maps
        </Link>
      </Grid>
    </Grid>
  );
}

function VenueEdit({ data, setPayload }: any) {
  const [coord, setCoord] = useState({});
  const [imageKey, setImageKey] = useState<string>(
    'profile_picture' + data._id + uuid()
  );
  const { token } = useAppSelector((state) => state.auth);
  const onFieldEdit = (e: any) => {
    setPayload({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  const onLocationEdit =
    (type: 'lng' | 'lat'): any =>
    (e: any) => {
      let obj: any = {
        ...coord,
      };
      if (type === 'lng') {
        obj.lng = parseFloat(e.target.value) || 0;
      } else {
        obj.lat = parseFloat(e.target.value) || 0;
      }
      setCoord(obj);
      setPayload({
        ...data,
        location: { type: 'Pont', coordinates: [obj.lat || 0, obj.lng || 0] },
      });
    };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Chip label={data.uuid} variant='outlined' />
      </Grid>
      <Grid item xs={12}>
        <FormImageLeftStyled
          id={imageKey}
          key={imageKey}
          sx={{
            backgroundImage: `url(${config.backendPath}/api/admin/v1/file/profile/${data.uuid}?q=${imageKey})`,
          }}
        />
        <FileUpload
          uploadUrl={`/api/admin/v1/file/upload/${data.uuid}?cover=true`}
          token={token}
          onSuccess={() => {
            setImageKey('profile_picture' + data._id + uuid());
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Unique Itendifier'
          name='uuid'
          defaultValue={data.uuid}
          size={'small'}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Name'
          name='name'
          defaultValue={data.name}
          size={'small'}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Address'
          name='address'
          multiline
          maxRows={10}
          defaultValue={data.address}
          size={'small'}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextField
          label='latitude'
          name='Latitude'
          size={'small'}
          defaultValue={data.location.coordinates[0]}
          onBlur={onLocationEdit('lat')}
          fullWidth={true}
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextField
          label='longitude'
          name='Longitude'
          size={'small'}
          defaultValue={data.location.coordinates[1]}
          onBlur={onLocationEdit('lng')}
          fullWidth={true}
        />
      </Grid>
    </Grid>
  );
}

export { VenueReadOnly, VenueEdit };
